import { render } from "./OrganismsChartQuadrant.vue?vue&type=template&id=358e8792&ts=true"
import script from "./OrganismsChartQuadrant.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganismsChartQuadrant.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/organisms/OrganismsChartQuadrant.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "358e8792"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('358e8792', __exports__)) {
    api.reload('358e8792', __exports__)
  }
  
  module.hot.accept("./OrganismsChartQuadrant.vue?vue&type=template&id=358e8792&ts=true", () => {
    api.rerender('358e8792', render)
  })

}


export default __exports__